import organisations from "./organisations";

export const ORGANISATIONS_NAMESPACE = "organisations";

export default organisations;
